import { toast } from "react-toastify";
import Modal from "../../../ui/Modal";
import { CheckCircle2, Calendar } from "lucide-react";
import { downloadMeetingCalendar } from "../../../../services/meeting";

const BookingSuccessModal = ({ 
  isOpen, 
  onClose, 
  bookingDetails 
}) => {
  const handleDownloadIcs = async () => {
    if (!bookingDetails?.id) {
      toast.error("Booking information is missing.");
      return;
    }

    try {
      const response = await downloadMeetingCalendar(bookingDetails.id);
      
      // Create a blob from the response data
      const blob = new Blob([response.data], { type: 'text/calendar' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `meeting_${bookingDetails.id}.ics`);
      document.body.appendChild(link);
      link.click();
      
      // Cleanup
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
      
      toast.info("Calendar file downloaded. Open it to add to your calendar.");
    } catch (error) {
      console.error("Error downloading calendar file:", error);
      toast.error("Failed to download calendar file.");
    }
  };


  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title=""
      showCloseButton={true}
      maxWidth="max-w-lg"
    >
      <div className="pb-4 flex flex-col items-center">
        {/* Success Icon */}
        <div className="w-14 h-14 bg-emerald-50 rounded-full flex items-center justify-center mb-2 shadow-sm ring-4 ring-emerald-50/50">
          <CheckCircle2 size={40} className="text-[#4CAF50]" strokeWidth={2.5} />
        </div>

            {/* Text Content */}
            <div className="text-center mb-8 px-4">
              <h2 className="section-heading text-2xl mb-2">
                {bookingDetails?.isAutoApproved ? "Meeting Booked Successfully!" : "Booking Request Sent!"}
              </h2>
              <p className="section-subheading text-base max-w-sm mx-auto text-gray-600">
                {bookingDetails?.isAutoApproved 
                  ? "Your appointment has been confirmed. You can now add this to your calendar to stay notified."
                  : "Your booking is currently pending approval. We'll notify you once it's confirmed by the host."
                }
              </p>
            </div>

        {/* Meeting Details Table */}
        <div className="w-full bg-slate-50 border border-slate-200 rounded-2xl overflow-hidden mb-8">
          <div className="bg-white border-b border-slate-200 py-3.5 px-6">
            <span className="table-col-name">
              <Calendar size={14} />
              Meeting Details
                </span>
              </div>
              
          <div className="px-6 py-2 divide-y divide-slate-100">
            <div className="flex items-center justify-between py-4">
              <span className="form-label text-gray-500">Exhibitor</span>
              <span className="text-sm font-semibold text-gray-900">{bookingDetails?.exhibitor_name}</span>
                  </div>
            <div className="flex items-center justify-between py-4">
              <span className="form-label text-gray-500">Date</span>
              <span className="text-sm font-semibold text-gray-900">{bookingDetails?.date}</span>
                  </div>
            <div className="flex items-center justify-between py-4">
              <span className="form-label text-gray-500">Time</span>
              <span className="text-sm font-bold text-[#4CAF50]">{bookingDetails?.time}</span>
                </div>
              </div>
            </div>

        {/* Add to Calendar Button - Only show if confirmed */}
        {bookingDetails?.isAutoApproved && (
          <button onClick={handleDownloadIcs} className="site-color-btn w-full justify-center py-3 shadow-sm hover:shadow-md transition-all active:scale-[0.98]">
             <Calendar size={18} />
                  Add to Calendar
          </button>
        )}
            </div>
    </Modal>
  );
};

export default BookingSuccessModal;
